document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".bestsellers-slider", {
    slidesPerView: 3,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".relatedslider", {
    slidesPerView: 3,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  initCustomerAlsoPurchasedSlider();
});

function initCustomerAlsoPurchasedSlider() {
  var swiper = new Swiper(".customeralsopurchasedslider", {
    slidesPerView: 3,
    loop: true,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 16,
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {

  var productSlider = new Swiper(".productslider", {
    slidesPerView: 1,
    allowTouchMove: false,
    loop: true,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      0: {
        allowTouchMove: true,
        centeredSlides: true,
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 1,
      }
    }
  });

  var dieselSlider = new Swiper(".dieselextremeImageSlider", {
    slidesPerView: 1,
    allowTouchMove: false,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });

  // 🔗 TRUE two-way sync (fixes skipping)
  productSlider.controller.control = dieselSlider;
  dieselSlider.controller.control = productSlider;

});

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".notsuredieselextremeslider", {
    slidesPerView: 1.3,
    allowTouchMove: false,
    centeredSlides: false,
    loop: true,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      0: {
        allowTouchMove: true,
        centeredSlides: true,
        slidesPerView: 1.4,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 1.3,
        spaceBetween: 16,
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const hamburger = document.querySelector(".hamburger");
  const leftMenu = document.querySelector(".left-menu");

  hamburger.addEventListener("click", function () {
    hamburger.classList.toggle("active");
    leftMenu.classList.toggle("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const svgs = document.querySelectorAll(".lower-headerbox .left-menu ul li a svg");

  svgs.forEach(function (svg) {
    svg.addEventListener("click", function (event) {
      // Stop link navigation
      event.preventDefault();

      // Find the closest <li>
      const li = svg.closest("li");

      // Toggle the 'active' class
      if (li) {
        li.classList.toggle("active");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const spans = document.querySelectorAll(".footerbox .footeritem span");
  spans.forEach(function (span) {
    span.addEventListener("click", function () {
      // Find the sibling <nav> within the same .footeritem
      const nav = span.parentElement.querySelector("nav");

      // Toggle the 'active' class on that <nav>
      if (nav) {
        nav.classList.toggle("active");
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  function adjustNotsureContainer() {
    const shopContainer = document.querySelector('.shopbybrand .container');
    const notsureContainer = document.querySelector('.notsurewhichtank .notsurecontainer');

    if (!shopContainer || !notsureContainer) return;

    // Get left offset of the .shopbybrand .container relative to viewport
    const leftOffset = shopContainer.getBoundingClientRect().left;

    // Apply margin-left + 15px padding as inline style
    notsureContainer.style.marginLeft = `${leftOffset}px`;
  }

  // Run on load and resize
  window.addEventListener('load', adjustNotsureContainer);
  window.addEventListener('resize', adjustNotsureContainer);

});

document.addEventListener("DOMContentLoaded", function () {
    const faqQuestions = document.querySelectorAll(".faqquestion");

    faqQuestions.forEach((question) => {
        question.addEventListener("click", function () {
            const answer = this.nextElementSibling;

            // Accordion behavior: close others
            document.querySelectorAll(".faqanswer").forEach((otherAnswer) => {
                if (otherAnswer !== answer) {
                    otherAnswer.style.maxHeight = null;
                    otherAnswer.previousElementSibling.classList.remove("active");
                }
            });

            // Toggle current answer
            this.classList.toggle("active");
            if (answer.style.maxHeight) {
                // Close
                answer.style.maxHeight = null;
            } else {
                // Open
                answer.style.maxHeight = answer.scrollHeight + "px";
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".passwordeye");
  const passwordField = document.getElementById("user_password");
if (toggle && passwordField) {
  toggle.addEventListener("click", function () {
    const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
    passwordField.setAttribute("type", type);

  });
}
});

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".registerpasswordeye");
  const passwordField = document.getElementById("user_password");
if (toggle && passwordField) {
  toggle.addEventListener("click", function () {
    const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
    passwordField.setAttribute("type", type);

  });
}
});

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".registerpasswordeye");
  const passwordField = document.getElementById("RegisterForm-password");
if (toggle && passwordField) {
  toggle.addEventListener("click", function () {
    const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
    passwordField.setAttribute("type", type);

  });
}
});






document.addEventListener("DOMContentLoaded", function() {
  const nameFields = ['userfirstname', 'userlastname'];

  nameFields.forEach(id => {
    const input = document.getElementById(id);

    if (input) {
      input.addEventListener('input', function() {
        // Replace anything that's not a letter or space
        this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".productImageMiniSlider", {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".customerreviewsSlider", {
    slidesPerView: 3,
    loop:true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".reviewswiper-button-next",
      prevEl: ".reviewswiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      }
    }
  });
});

